﻿<script>
  export let className;
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  class={className}>
  <g transform="matrix(1,0,0,1,0,0)">
    <path
      d="M0.714 10.353L3.501 14.503 6.706 10.665"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M23.286 14.655L20.501 10.503 17.294 14.342"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M20.464,10.54a8.622,8.622,0,0,1-6.51,9.729,8.493,8.493,0,0,1-7.931-2.224"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M3.505,14.479A8.853,8.853,0,0,1,10.043,3.726a8.493,8.493,0,0,1,8.324,2.642"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </g>
</svg>
